export class OutlookResponse {
    displayName: string;
    jobTitle: string;
    email: string;
    phone: string;
}